<template>
  <table
      class="drp-calendar"
  >
    <thead>
    <tr>
      <td :colspan="showWeek ? 8 : 7">
        {{ monthFormatted }}
      </td>
    </tr>
    <tr>
      <th v-if="showWeek"></th>
      <th scope="col">Mo</th>
      <th scope="col">Di</th>
      <th scope="col">Mi</th>
      <th scope="col">Do</th>
      <th scope="col">Fr</th>
      <th scope="col">Sa</th>
      <th scope="col">So</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(week) in view.weeks" :key="week.formatted">
      <th  v-if="showWeek" scope="row">{{ week.formatted }}</th>
      <td
          v-for="day in week.days"
          :key="day.formatted"
          class="day"
          :class="getDateClasses(day)"
          @mouseover="!day.isDisabled && $emit('hover:date', day.date)"
          @click="!day.isDisabled && $emit('click:date', day.date)"
      ><span>{{ day.formatted }}</span></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, format } from 'date-fns';
import { de } from 'date-fns/locale'
export default {
  name: "Calendar",
  props: {
    month: Date,
    date_classes: {
      type: Function,
      required: false,
      default: () => () => ([])
    },
    min_date: {
      type: Date,
      required: false,
      default: () => null
    },
    max_date: {
      type: Date,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      showWeek: false,
    };
  },
  computed: {
    monthFormatted() {
      return format(this.month, 'MMMM, yyyy', {locale: de });
    },
    view() {
      const currentMonth = this.month.getMonth();
      const startOfMonthTs = startOfMonth(this.month).getTime();
      const endOfMonthTs = endOfMonth(this.month).getTime();
      const startOfView = startOfWeek(startOfMonth(this.month), { weekStartsOn: 1 });
      const endOfView = endOfWeek(endOfMonth(this.month), { weekStartsOn: 1 });

      const weeks = [];
      let sow = startOfView;
      let eow = addDays(sow, 6);
      while (sow.getTime() < endOfView.getTime()) {
        const days = [];
        for (let day = sow; day.getTime() <= eow.getTime(); day = addDays(day, 1)) {
          const isCurrentMonth = day.getMonth() === currentMonth;
          days.push({
            date: day,
            formatted: format(day, 'd'),
            isDisabled: !isCurrentMonth
              || (this.min_date instanceof Date && this.compareDate(day, this.min_date) < 0)
              || (this.max_date instanceof Date && this.compareDate(day, this.max_date) > 0),
            isCurrentMonth: isCurrentMonth,
            isPrevMonth: day.getTime() < startOfMonthTs,
            isNextMonth: endOfMonthTs < day.getTime()
          });
        }
        weeks.push({
          formatted: format(sow, 'w'),
          days
        });
        sow = addDays(eow, 1);
        eow = addDays(sow, 6);
      }
      return {
        weeks
      };
    }
  },
  methods: {

    compareDate(a, b) {
      return Math.floor(a.getTime() / 86400000) - Math.floor(b.getTime() / 86400000);
    },

    getDateClasses(day) {
      let classes = [];
      if (day.isDisabled) {
        classes.push('disabled');
      }
      if (day.isPrevMonth) {
        classes.push('is-prev-month');
      }
      if (day.isNextMonth) {
        classes.push('is-next-month');
      }
      let value = this.date_classes;
      if (typeof value === 'function') {
        value = value(day.date);
      }
      if (Array.isArray(value)) {
        Array.prototype.push.apply(classes, value);
      } else if (typeof value === 'string') {
        classes.push(value);
      }

      return classes;
    }

  }
}
</script>

<style lang="scss">
  table {
    border: none;
  }
  td, th {
    min-width: 36px;
    height: 36px;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    padding: 0;
    border: none;
  }
  tbody td,
  tbody th,
  tbody td.day {

    span {
      display: block;
      min-width: 36px;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      text-align: center;
      cursor: pointer;
    }

    &.today {
      background-color: #eaeaea;
      font-weight: 700;
    }

    &.in-range span {
      background-color: #ea7819;
      color: #fff;
    }

    &.start-of-range span,
    &.end-of-range span {
      background-color: #910A0A;
      color: #fff;
    }

    &.disabled {
      span {
        color: #ccc;
      }
      pointer-events: none;
    }

    &.is-prev-month span,
    &.is-next-month span {
      display: none;
    }

    &:hover span {
      background-color: #910A0A;
      color: #fff;
    }

  }
</style>
